import { Box, createStyles, Icon, makeStyles } from '@material-ui/core'
import { SelectBox, OptionListType } from '../SelectBox'
import { Colors } from '../Colors'
import { SvgIcon } from '../SvgIcon'
import { useEffect } from 'react'

export interface VariadicSelectBoxProps {
  placeholder?: string
  values: (string | number)[]
  optionList: OptionListType[]
  onChange: (index: number, value: string | number) => void
  addField: () => void
  removeField: (index: number) => void
  height?: string | number
  size?: 'small' | 'medium'
  limit?: number
}

const useStyles = makeStyles(() =>
  createStyles({
    row: {
      display: 'flex',
      alignItems: 'center',
      height: ({ height, size = 'small' }: VariadicSelectBoxProps) => {
        if (height !== undefined) return height
        switch (size) {
          case 'small':
            return '28px'
          case 'medium':
            return '34px'
          default:
            return '28px'
        }
      }
    },
    field: {
      width: '75.3%',
      height: '100%'
    },
    addIconBox: {
      width: '10%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer'
    },
    deleteIconBox: {
      width: '8%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },
    firstField: {
      width: '83.3%'
    },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
)

const VariadicSelectBox = (props: VariadicSelectBoxProps) => {
  const { placeholder, values, optionList, height, limit, onChange, addField, removeField } = props
  const classes = useStyles(props)
  const effectiveLimit = Math.min(limit || optionList.length, optionList.length)
  const limitReached = values.length >= effectiveLimit

  const handleAddField = () => {
    if (limitReached) return
    addField()
  }

  const lastIndex = values.length - 1

  // 初期のフォーム数を1に設定
  useEffect(() => {
    if (values.length === 0) {
      addField()
    }
  }, [addField, values.length])

  return (
    <Box>
      {values.map((row, index) => {
        const isFirstField = index === 0
        const isLastField = lastIndex === index
        return (
          <>
            {!isFirstField && <Box height="12px" />}
            <Box key={`vsb${index}`} className={classes.row}>
              {index !== 0 && (
                <Box className={classes.deleteIconBox}>
                  <Icon onClick={() => removeField(index)} className={classes.icon}>
                    <SvgIcon variant="removeCircle" size="24px" color={Colors.secondary.default} />
                  </Icon>
                </Box>
              )}
              <Box className={isFirstField ? classes.firstField : classes.field}>
                <SelectBox
                  value={row}
                  onChange={e => onChange(index, e.target.value as string | number)}
                  optionList={optionList}
                  placeholder={placeholder}
                  height={height}
                />
              </Box>
              {isLastField && !limitReached && (
                <Box className={classes.addIconBox}>
                  <Icon onClick={handleAddField} className={classes.icon}>
                    <SvgIcon variant="addCircle" size="24px" color={Colors.base.middleGray} />
                  </Icon>
                </Box>
              )}
            </Box>
          </>
        )
      })}
    </Box>
  )
}

export default VariadicSelectBox
